import { render } from "./ProvideOriginalPage.vue?vue&type=template&id=010862f8&ts=true"
import script from "./ProvideOriginalPage.ts?vue&type=script&lang=ts&external"
export * from "./ProvideOriginalPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__